/**
 * First-run funnel events.
 *
 * Thin wrapper over the GA4 helper so the /start flow and the dashboard
 * checklist emit one consistent set of event names. Analytics must never
 * break the flow, so every call is best effort and silent on failure.
 *
 * Events, in funnel order:
 *   signup_completed
 *   start_template_selected      { template }
 *   start_test_response_recorded
 *   start_test_response_skipped
 *   start_case_viewed
 *   form_shared                  { source }
 *   destination_connected        { destination }
 *   checklist_completed
 */
import { fireGA4Event } from './analyticsEvents';

export const FIRST_RUN_EVENTS = [
  'signup_completed',
  'start_template_selected',
  'start_test_response_recorded',
  'start_test_response_skipped',
  'start_case_viewed',
  'form_shared',
  'destination_connected',
  'checklist_completed',
];

export const trackFirstRunEvent = (eventName, params = {}) => {
  try {
    fireGA4Event(eventName, { event_category: 'first_run', ...params });
  } catch (e) {
    // Never let analytics break onboarding.
  }
};

export default trackFirstRunEvent;
